import Grid from '@material-ui/core/Grid';
import PickupRequest from './pickupRequest';
import Counter from './counter';
import ParcelEntry from './parcel_entry';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import PaymentIcon from '@material-ui/icons/Payment';

export default function Dashboard() {
  return (
    <Grid container spacing={3} style={{ padding: '20px' }}>
      <Grid item xs={12} md={12} lg={12}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <PickupRequest />
          </div>
          <div>
            <Link to="/dashboard/payment/request" style={{ textDecoration: 'none' }}>
              <Button variant="contained" color="primary" startIcon={<PaymentIcon />}>
                Payment Request
              </Button>
            </Link>
          </div>
        </div>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <div className="grid grid-cols-1 md:grid-cols-1">
          <div>
            <Counter />
          </div>
          <div className="mt-4">
            <ParcelEntry />
          </div>
        </div>
      </Grid>
    </Grid>
  );
}
